import { textStyleCss } from 'src/theme/atlas';
import styled, { css } from 'styled-components';

export const formLabelSmallSemibold = css`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)};
  font-weight: 600;
`;

export const formButtonMediumSemibold = css`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.button)};
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
`;

export const AuditLogText = styled.button.attrs<{ disabled?: boolean }>(
  (props) => ({
    type: 'button',
    disabled: props.disabled ?? false,
  }),
)`
  ${formButtonMediumSemibold}
  background: none;
  border: 0;
  padding: 0;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;

  &:hover:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
    cursor: not-allowed;
    opacity: 0.4;
  }

  &:focus-visible {
    outline: 2px solid
      ${(props) => props.theme.atlas.semantic.color.ui.focusRing};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;
